import {XANADU} from '../transactions/contracts.js';
import XanaduContract from '../contracts/XanaduContract.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import EthereumQuery from 'decentralized/EthereumQuery.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';
import EthereumTransaction from '../transactions/EthereumTransaction.js';
import {PACK_TYPE} from './LinkTypes.js';
import {
    NewAnnotationType,
    NewAnnotation,
    NewLinkType,
    NewLink,
    NewDataType
} from 'decentralized/EthereumEvents.js';

export default superclass => class extends superclass  {
    async syncPadType(hash, type) {
        await new EthereumTransaction(
            XANADU,
            'newAnnotation',
            [
                this.web3.utils.fromAscii(PACK_TYPE),
                ipfsHashToBytes32(hash),
                this.web3.utils.fromAscii(type)])
            .execute();
    }

    async getPacksWithType(hashes, type, user) {
        let query = new BackendQuery(new XanaduContract().contractAddress)
            .from(NewAnnotation)
            .select('data')
            .select('annotationData')
            //.where('annotationType', PACK_TYPE)
            .where('annotationData', type)

        let ret = await query.executeQuery();
        return ret.map(x => x.data);
    }
}
